import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface LiveTvIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const LiveTvUnifiedIcon = observer('LiveTvIcon', ({ className, onClick }: LiveTvIconPropsType): JSX.Element => {
    return (
        <SvgElement
            className={className}
            height='24'
            onClick={onClick}
            viewBox='0 0 24 24'
            width='24'
            fill='#131419'
            xmlns='http://www.w3.org/2000/svg'
        >
            <mask
                id='mask0_2321_32200'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='1'
                y='2'
                width='18'
                height='16'
            >
                <path
                    d='M7.91666 12.9167L13.75 9.16667L7.91666 5.41667V12.9167ZM6.66666 17.5V15.8333H3.33332C2.87499 15.8333 2.48263 15.6701 2.15624 15.3437C1.82985 15.0174 1.66666 14.625 1.66666 14.1667V4.16667C1.66666 3.70833 1.82985 3.31597 2.15624 2.98958C2.48263 2.66319 2.87499 2.5 3.33332 2.5H16.6667C17.125 2.5 17.5174 2.66319 17.8437 2.98958C18.1701 3.31597 18.3333 3.70833 18.3333 4.16667V14.1667C18.3333 14.625 18.1701 15.0174 17.8437 15.3437C17.5174 15.6701 17.125 15.8333 16.6667 15.8333H13.3333V17.5H6.66666Z'
                    fill='#1C1B1F'
                />
            </mask>
            <g mask='url(#mask0_2321_32200)'>
                <rect
                    width='20'
                    height='20'
                />
            </g>
        </SvgElement>
    );
});
